import React, {createContext, useContext} from 'react'
import PropTypes from 'prop-types'

const GDIDynamicContentContext = createContext({})

/**
 * Provides the dynamic content values consumed by GDI CMS blocks (notably
 * `gdiTextBlock`) when expanding inline `{tokenName}` tags inside authored
 * HTML. Hosts wrap a subtree of CMS content with this provider and pass a
 * `value` object whose keys correspond to the tokens that should resolve.
 *
 * Recognised keys (all optional — tokens with no value are left untouched
 * in the authored text):
 *   - pdpLoyaltyPoints, loyaltyCustomerFirstName,
 *     loyaltyMissingQualifyingPoints, loyaltyNextTier, loyaltyDueDate
 *     → simple string substitutions.
 *   - closeParentModal: () => void
 *     → optional callback invoked by interactive tokens (e.g. the
 *       `{newsletterForm}` Subscribe button) after a successful action when
 *       the CMS content is embedded inside a modal/drawer. Hosts that
 *       render the provider inside a drawer should pass their `onClose`
 *       here so the drawer closes after submit. Non-modal hosts leave it
 *       undefined and the token simply skips the close step.
 */
export const GDIDynamicContentProvider = ({children, value}) => {
    return (
        <GDIDynamicContentContext.Provider value={value || {}}>
            {children}
        </GDIDynamicContentContext.Provider>
    )
}

export const useGDIDynamicContentContext = () => useContext(GDIDynamicContentContext)

GDIDynamicContentProvider.propTypes = {
    children: PropTypes.node,
    value: PropTypes.object
}
